import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app              from './app';
import appConfig        from './app-config';
import verticalMenu     from './vertical-menu';
import atencionCita     from './atencionCita';
import admision         from './admision';
import saveLocalStorage from './saveLocalStorage';
import atencionMedica   from './atencionMedica';
import derivaciones     from './derivaciones';
import terapias         from './terapias/terapias';
import auth             from './auth';
import docsMsps         from './docsMsps';
import generals         from './generals/filterTables';
import detailsCita      from './detailsCita';
import citas from './citas';
import odontologia from './odontologia';
import auditoria from './auditoria';

Vue.use(Vuex)

export default new Vuex.Store({

  state: {
    comentarios: {},
    estadoSignosVital: '0',
    diagnosticos: [],
  },
  mutations: {
    
    setEstadoSignosVital(state, valor) {
      state.estadoSignosVital = valor;
    },
    
    addDiagnostico(state, nuevoDiagnostico) {
      state.diagnosticos.push(nuevoDiagnostico);
    },
    removeDiagnostico(state, index) {
      state.diagnosticos.splice(index, 1);
    },
  },
  
  modules: {
    app,
    appConfig,
    verticalMenu,
    admision,
    atencionCita,
    atencionMedica, 
    derivaciones,
    terapias,
    auth,
    docsMsps,
    generals,
    detailsCita,
    citas,
    odontologia,
    auditoria
  },

  actions: {
    addComentario({ commit }, id) {
      const commentsAnamnesis = {
        tipoConsulta: [{ comment: "", auditado: 0 }],
        motivoConsulta: [{ comment: "", auditado: 0 }],
        problemaActual: [{ comment: "", auditado: 0 }],
        planTratamiento: [{ comment: "", auditado: 0 }],
        antePersonales: [{ comment: "", auditado: 0 }],
        anteFamiliares: [{ comment: "", auditado: 0 }],
        revOrganos: [{ comment: "", auditado: 0 }],
        diagnosticos: [{
          comment: "", auditado: 0 
        }]
      };
      
      commit('ADD_COMENTARIO', { id, commentsAnamnesis });
    },

    updateComentarioField({ commit }, { id, field, index, newValue }) {
      commit('UPDATE_COMENTARIO_FIELD', { id, field, index, newValue });
    },

    setEsDerivacion({ commit }, nuevoValor) {
      commit('setEsDerivacion', nuevoValor);
    },

    addDiagnostico({ commit }, nuevoDiagnostico) {
      commit('addDiagnostico', nuevoDiagnostico);
    },
    removeDiagnostico({ commit }, index) {
      commit('removeDiagnostico', index);
    },
  },
  strict: process.env.DEV,

  plugins: [saveLocalStorage]
})
